<template>
  <table class="rush-table table text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col">Раж</th>
        <th scope="col">Присоединение</th>
        <th scope="col">Участник ража</th>
        <th scope="col" class="text-right">Количество заездов</th>
      </tr>
    </thead>
    <tr
      v-for="rush in rushes"
      :key="rush.rushId"
    >
      <td>
        <rush-link :rushId="rush.rushId" label="раж" />
      </td>
      <td>{{rush.firstRaceJoinTime | getMomentStr}}</td>
      <td>
        <rush-player-link :rushPlayerId="createRushPlayerId(rush.rushId)">
          участник ража
        </rush-player-link>
      </td>
      <td class="text-right">
        <router-link :to="{name: 'rush_player_races', params: {playerId: playerId, rushId: rush.rushId}}">
          {{rush.raceAmount | getFormattedNumber}}
        </router-link>
      </td>
    </tr>
  </table>
</template>

<script>
import RushLink       from './RushLink.vue';
import RushPlayerLink from './RushPlayerLink.vue';

export default {
  name: 'PlayerRushPreviewsTable',

  components: {
    RushLink,
    RushPlayerLink,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    rushes: {
      type: Array,
      required: true,
    },
  },

  methods: {
    /** @param {number} rushId */
    createRushPlayerId(rushId) {
      return {
        rushId: rushId,
        playerId: this.playerId,
      };
    },
  },
};
</script>

<style scoped>
.rush-table {
  width: 1px;
}
</style>
